import { render } from "./invest.vue?vue&type=template&id=21cc9a0c&scoped=true"
import script from "./invest.vue?vue&type=script&lang=js"
export * from "./invest.vue?vue&type=script&lang=js"

import "./invest.vue?vue&type=style&index=0&id=21cc9a0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21cc9a0c"

export default script